import { render, staticRenderFns } from "./SearchSlipsPopup.vue?vue&type=template&id=6c51064a&scoped=true&"
import script from "./SearchSlipsPopup.vue?vue&type=script&lang=js&"
export * from "./SearchSlipsPopup.vue?vue&type=script&lang=js&"
import style0 from "./SearchSlipsPopup.vue?vue&type=style&index=0&id=6c51064a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c51064a",
  null
  
)

export default component.exports